import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Prof. Anki Reddy Katha",
        "NameLink": "https://iittp.ac.in/dr-anki-reddy-katha",
        "Position": "Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India.",
        "AreasofInterest": "Energy and Environmental Sciences, Granular Physics.",
        "Phone": " ",
        "Email": "anki.reddy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/anki.jpg"

    }
]
const Faculty = [
   

    {
        "Name": "Prof.  Arun K. Tangirala",
        "NameLink": "https://iittp.ac.in/prof-arun-k-tangirala",
        "Position": "Professor",
        "Degree": "Ph.D - University of Alberta, Edmonton.",
        "AreasofInterest": "Process Systems Engineering, Data Science & Artificial Intelligence",
        "Phone": " ",
        "Email": "arunkt@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof_Arun_K_Tangirala.png"
    },
    
    
    {
        "Name": "Prof. KSMS Raghavarao",
        "NameLink": "https://iittp.ac.in/dr-ksms-raghavarao",
        "Position": "Professor",
        "Degree": "Ph.D - Institute of Chemical Technology (UICT), Mumbai, India.",
        "AreasofInterest": "Food Process Engineering; Separation Processes.",
        "Phone": " - ",
        "Email": "raghava@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/raghavarao.png"
    },
    {
        "Name": "Dr. Sasidhar Gumma",
        "NameLink": "https://iittp.ac.in/dr-sasidhar-gumma",
        "Position": "Professor",
        "Degree": "Ph.D - Cleveland State University",
        "AreasofInterest": "Metal organic frameworks, Adsorption.",
        "Phone": "0877 250 3671",
        "Email": "s.gumma@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SG.jpg"
    },
    {
        "Name": "Prof.Thamida Sunil Kumar",
        "NameLink": "https://iittp.ac.in/dr-thamida-sunil-kumar",
        "Position": "Professor",
        "Degree": "Ph.D - University of Notre Dame, USA.",
        "AreasofInterest": "Microfluidics and Corrosion Simulation.",
        "Phone": "9492079213",
        "Email": "sunil76@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg" 
    },
    {
        "Name": "Dr. M Nabil",
        "NameLink": "https://iittp.ac.in/dr-m-nabil",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IIT Madras, India.",
        "AreasofInterest": "Process Optimization & Control, Machine Learning for Process Systems",
        "Phone": "7558183597",
        "Email": "nabil@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Nabil.png"
    },
    
    {
        "Name": "Dr. Anil Vir",
        "NameLink": "https://iittp.ac.in/dr-anil-vir",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology (IIT) Madras, India.",
        "AreasofInterest": "Microreactor and multiphase reaction",
        "Phone": "9840269624",
        "Email": "anilvir@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/anilvir.jpg"
    },
    {
        "Name": "Dr. Brindha Moorthy",
        "NameLink": "https://iittp.ac.in/dr-brindha-moorthy",
        "Position": "Assistant Professor",
        "Degree": "Ph.D., KAIST, South Korea.",
        "AreasofInterest": "Materials Science and Engineering, Functional Materials for Energy Storage Applications.",
        "Email": "brindha.m@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Brindha_Moorthy_AP.jpg"
    },
    
    {
        "Name": "Dr. Narendra Singh",
        "NameLink": "https://iittp.ac.in/dr-narendra-singh",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India.",
        "AreasofInterest": "Photocatalysis, Surface engineering of polymer and metal surfaces",
        "Phone": "+91-9936337743",
        "Email": "narendra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Narendra Singh.jpg"
    },
    {
        "Name": "Dr. Nilesh Choudhary",
        "NameLink": "https://iittp.ac.in/dr-nilesh-choudhary",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Academy of Scientific and Innovative Research (CSIR-NCL)",
        "AreasofInterest": "Multi-scale molecular simulation for applied materials and complex systems",
        "Email": "nilesh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/nilesh.jpeg"
    },
    {
        "Name": "Dr. Ranjith Thangavel",
        "NameLink": "https://iittp.ac.in/dr-ranjith-thangavel",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Chonnam National University, South Korea",
        "AreasofInterest": "Li-ion batteries, Na-ion batteries and beyond, Catalysis for electrochemical energy conversion",
        "Email": "ranjith.t@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Ranjith_AP.png"
    },
    {
        "Name": "Dr. Shamik Misra",
        "NameLink": "https://iittp.ac.in/dr-shamik-misra",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian institute of Technology Bombay, India",
        "AreasofInterest": "Process systems engineering, Renewable energy, and sustainability",
        "Email": "misra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/misra.PNG"
    },
    {
        "Name": "Dr. Trivikram Nallamilli",
        "NameLink": "https://iittp.ac.in/dr-trivikram-nallamilli",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Colloid and interfacial Phenomena, Soft matter and Food physics",
        "Email": "trivikram@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/trivikram.jpg"
    },
    {
        "Name": "Dr. S Uday Kumar",
        "NameLink": "https://iittp.ac.in/dr-s-uday-kumar",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IIT - Roorkee, Roorkee, India",
        "AreasofInterest": "Nanobiotechnology and Biomaterials",
        "Email": "udaykumar@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/uday.jpg"
    }




]

// const AdjunctFaculty = [


//     {
//         "Name": "Prof. K.Krishnaiah",
//         "NameLink": "https://iittp.ac.in/dr-k-krishnaiah",
//         "Position": "Professor",
//         "Degree": "Ph.D - Indian Institute of Technology, Madras, India.",
//         "AreasofInterest": "Chemical Reactor Analysis and Design, Fluidization.",
//         "Phone": "0877 2503010",
//         "Email": "krishnak@iittp.ac.in",
//         "Image": "https://files.iittp.ac.in/images/demo/iit/krishnaiah.jpg"
//     },


// ]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="CHEMICAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                            
                            <h3>CHEMICAL ENGINEERING</h3>
                        </div>
                    </div>
                </div>

                <div className="container">


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={1} />
                        </Col>
                        <Col md={9} className='c-right'>

                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{Faculty.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> <b>Email</b> : {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> <b>Email</b> : {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                                  {/*--------------------------- Adjunct Faculty*/}
                            {/* <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty</h3>
                                {AdjunctFaculty.map((AdjunctFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={AdjunctFaculty.NameLink}>
                                                        <img src={AdjunctFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={AdjunctFaculty.NameLink}>{AdjunctFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{AdjunctFaculty.Position}</p>
                                                    <p className="text-dark">{AdjunctFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {AdjunctFaculty.AreasofInterest}</p>

                                                    {(AdjunctFaculty.Phone !== undefined && AdjunctFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{AdjunctFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {AdjunctFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}


                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main